module.exports = __webpack_public_path__ + "media/src/images/icons/github-8f00dfea1c2890a97be16033abe2cfd1.png";